import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as XLSX from 'xlsx'; // SPREADSHEET RELATED
import { PODYear, OutcomeReportApi, OutcomeRequestApi, OutcomeService } from 'src/app/services/outcome.service';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  reports: OutcomeReportApi[] = [];
  reportYear: PODYear = null;
  years: number[] = [];
  today: Date = new Date();

  private unsubscribe: Subject<any> = new Subject();

  constructor(
    private outcomeService: OutcomeService,
    private router: Router,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.today = new Date();

    this.outcomeService.currentYears$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(years => {
        this.years = years;
    });

    this.outcomeService.currentReportYear$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(reportyear => {
      this.reportYear = reportyear;
      if (!!this.reportYear) {
        this.outcomeService.getReports(this.reportYear.year);
      }
    });

    if (!this.reportYear) {
      var paramYear = parseInt(this.route.snapshot.queryParams['reportyear']);
      if (isNaN(paramYear)) {
        this.reportYear = null;
      } else {
        this.reportYear = {year: paramYear};
      }
    }

    this.outcomeService.currentReports$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(data => {
      this.reports = data;
    });
  }

  updateReportYear($event) {
    this.reportYear = null;
    this.reportYear = {
      year: +$event.target.value,
    };
    this.outcomeService.changeReportYear(this.reportYear);
  }

  goback() {
    this.router.navigate(['/evaluate-outcomes'], {queryParams: { }})
  }

  export(): void {
    /* generate worksheet */
    var fileName = `Export-Outcomes-Report-${this.reportYear.year}.xlsx`;
    var tableHtml = document.getElementById('outcomereport');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(tableHtml);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName);
  }

}
